import { render, staticRenderFns } from "./ViewFolder.vue?vue&type=template&id=4afb8764&"
import script from "./ViewFolder.vue?vue&type=script&lang=js&"
export * from "./ViewFolder.vue?vue&type=script&lang=js&"
import style0 from "./ViewFolder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports